import { FC } from "react";

const GlobeIcon: FC = () => {
  return (
    <>
      <span className="GlobeIcon" />
      {/* language=CSS */}
      <style jsx>
        {`
          .GlobeIcon {
            font-family: "Font Awesome 5 Free-Solid-900";
            color: rgb(255, 54, 0);
            padding-top: 2px;
            line-height: 30px;
          }

          .GlobeIcon::before {
            /*noinspection CssInvalidPropertyValue*/
            content: "\f0ac";
          }
        `}
      </style>
    </>
  );
};

export default GlobeIcon;
